import { ExportImportCsvColumnNames } from './constants';
export var getColumnName = function (key) {
    return ExportImportCsvColumnNames[key];
};
//# sourceMappingURL=getColumnName.js.map